import axios from 'axios'
import { getAdminApiBase } from '../env'

export function fetchAlertsList(query) {
  const adminApiBase = getAdminApiBase()
  return axios
    .get(`${adminApiBase}/user/apex/admin/alerts?${query}`, {
      headers: {
        Authorization: `Token ${localStorage.getItem('token')}`
      }
    })
    .then(response => response)
}

// export function updateAlertApi(query, payload) {
//   return createAPIInstance().post(`user/apex/set/notification/state?${query}`, payload, {
//     headers: { 'Content-Type': 'application/json' }
//   })
// }
